import { jsx } from "panel";
import { ButtonEl } from "common/components/button";
import { UserIconEl } from "common/widgets/user-icon";
import { ButtonTheme, ButtonType } from "common/components/button/constants";
import { formatText } from "common/util/format-text";
const AnnotationRow = ({
  isEditingThisAnnotation,
  isPreview,
  canWriteAnnotations,
  annotationDescriptionDraft,
  isDeletingThisAnnotation,
  annotation,
  viewAnnotationsList
}) => /* @__PURE__ */ jsx("div", {
  sel: ".annotations-viewer-annotation-row",
  class: {
    "annotations-viewer-editing": isEditingThisAnnotation,
    "annotations-viewer-is-preview": isPreview
  },
  attrs: {
    elref: `annotationRow`
  }
}, !isEditingThisAnnotation ? /* @__PURE__ */ jsx("div", {
  sel: ".annotations-viewer-annotation-icon"
}, /* @__PURE__ */ jsx(UserIconEl, {
  attrs: {
    name: annotation.user && `${annotation.user.first_name} ${annotation.user.last_name}`,
    id: annotation.user && annotation.user.id,
    "disable-tooltip": true,
    size: `medium`
  }
})) : null, /* @__PURE__ */ jsx("div", {
  sel: ".annotations-viewer-annotation-content"
}, /* @__PURE__ */ jsx("div", {
  sel: ".annotations-viewer-annotation-header"
}, /* @__PURE__ */ jsx("div", {
  sel: ".annotations-viewer-annotation-meta"
}, annotation.user ? /* @__PURE__ */ jsx("div", {
  sel: ".annotations-viewer-annotation-user-label"
}, `${annotation.user.first_name} ${annotation.user.last_name && annotation.user.last_name[0]}`) : null, /* @__PURE__ */ jsx("div", {
  sel: ".annotations-viewer-annotation-date-label"
}, viewAnnotationsList.helpers.formatDate(annotation.highchartsDate))), canWriteAnnotations && !isEditingThisAnnotation && !isDeletingThisAnnotation ? /* @__PURE__ */ jsx("div", {
  sel: ".annotations-viewer-annotation-actions"
}, /* @__PURE__ */ jsx(ButtonEl, {
  sel: ".annotations-viewer-annotation-edit-button",
  attrs: { icon: `edit`, theme: ButtonTheme.Tertiary, elref: `annotationEdit` },
  on: { click: () => viewAnnotationsList.helpers.edit(annotation) }
}), /* @__PURE__ */ jsx(ButtonEl, {
  sel: ".annotations-viewer-annotation-delete-button",
  attrs: {
    icon: `trashcan`,
    theme: ButtonTheme.Tertiary,
    type: ButtonType.Destructive,
    elref: `annotationDelete`
  },
  on: { click: () => viewAnnotationsList.helpers.delete(annotation) }
})) : null), isEditingThisAnnotation ? /* @__PURE__ */ jsx("div", {
  sel: ".annotations-viewer-annotation-edit-mode"
}, /* @__PURE__ */ jsx("textarea", {
  on: { input: viewAnnotationsList.helpers.handleDescriptionChanged },
  attrs: { elref: `annotationTextArea`, maxlength: 512 }
}, annotation.description), /* @__PURE__ */ jsx("div", {
  sel: ".annotations-viewer-annotation-edit-actions"
}, /* @__PURE__ */ jsx(ButtonEl, {
  attrs: { theme: ButtonTheme.Tertiary },
  on: { click: viewAnnotationsList.helpers.editCanceled }
}, "Cancel"), /* @__PURE__ */ jsx(ButtonEl, {
  attrs: { theme: ButtonTheme.Primary, disabled: !annotationDescriptionDraft, elref: `annotationSave` },
  on: { click: viewAnnotationsList.helpers.save }
}, "Save"))) : /* @__PURE__ */ jsx("div", {
  sel: ".annotations-viewer-annotation-description",
  class: { "annotations-viewer-is-preview": isPreview }
}, formatText(annotation.description))), isDeletingThisAnnotation ? /* @__PURE__ */ jsx("div", {
  sel: ".annotations-viewer-confirm-delete-container"
}, /* @__PURE__ */ jsx("div", {
  sel: ".annotations-viewer-confirm-delete-buttons"
}, /* @__PURE__ */ jsx(ButtonEl, {
  attrs: { theme: ButtonTheme.Secondary },
  on: { click: viewAnnotationsList.helpers.deleteCanceled }
}, "Cancel"), /* @__PURE__ */ jsx(ButtonEl, {
  attrs: { theme: ButtonTheme.Primary, type: ButtonType.Destructive, elref: `annotationDeleteConfirm` },
  on: { click: viewAnnotationsList.helpers.deleteConfirmed }
}, "Delete"))) : null);
export function template() {
  const activeAnnotationButton = this.attr(`active-annotation`);
  const isPreview = this.attr(`type`) === this.helpers.AnnotationViewType.PREVIEW;
  const { activeAnnotationGroup, numAnnotations } = this.helpers.getActiveAnnotationGroup();
  const editingAnnotation = this.attr(`editing-annotation`);
  const deletingAnnotation = this.attr(`deleting-annotation`);
  return /* @__PURE__ */ jsx("div", {
    sel: ".annotations-viewer-container"
  }, activeAnnotationButton ? /* @__PURE__ */ jsx(null, null, /* @__PURE__ */ jsx("div", {
    sel: ".annotations-viewer-header",
    class: { "annotations-viewer-is-preview": isPreview }
  }, /* @__PURE__ */ jsx("div", {
    sel: ".annotations-viewer-header-date"
  }, activeAnnotationButton.formattedDate), /* @__PURE__ */ jsx("div", {
    sel: ".annotations-viewer-header-count"
  }, numAnnotations === 1 ? `${numAnnotations} Annotation` : `${numAnnotations} Annotations`)), /* @__PURE__ */ jsx("div", {
    sel: ".annotations-viewer-annotations-list"
  }, activeAnnotationGroup.map((annotation) => {
    return /* @__PURE__ */ jsx(AnnotationRow, {
      isEditingThisAnnotation: !!(editingAnnotation && editingAnnotation.id === annotation.id),
      isPreview,
      canWriteAnnotations: this.attr(`can-write-annotations`),
      annotationDescriptionDraft: this.attr(`annotation-description-draft`),
      isDeletingThisAnnotation: !!(deletingAnnotation && deletingAnnotation.id === annotation.id),
      annotation,
      viewAnnotationsList: this
    });
  })), /* @__PURE__ */ jsx("div", {
    sel: ".annotations-viewer-footer",
    class: { "annotations-viewer-is-preview": isPreview }
  }, isPreview ? numAnnotations > 2 ? `+ ${numAnnotations - 2} more...` : null : /* @__PURE__ */ jsx(ButtonEl, {
    on: { click: this.helpers.createAnnotation }
  }, "Add Annotation"))) : null);
}
